import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { Centers } from '../../models/Centers';
import { CentersService } from '../../services/CentersServices';

@Component({
  selector: 'centersdetails',
  templateUrl: './centersdetails.component.html',
  styleUrls: ['./centersdetails.component.scss'],
})
export class CentersDetailsComponent implements OnInit {
  model = {} as Centers;
  constructor(
    private sanitizer: DomSanitizer,
    private service: CentersService,
    private diag: NbDialogRef<CentersDetailsComponent>,
    private route : Router
  ) {}

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
 
  }
  downloadFile(fileName) {
    this.service.downloadFile(fileName).subscribe((blob) => {
      downloadFileUtil(blob, fileName);
    });
  }

  close() {
    this.diag.close();
  }
}
